import { SET_ALL_CATEGORY, SET_ALL_SUBCATEGORY, SET_SELECTED_CATEGORY } from "../types/actions/ProductAction";

export type InitialState = {
	categories: Array<{
		_id: string;
		name: string;
	}> | null;
	subcategories: Array<{
		name: string;
		category_id: string;
	}> | null;
	selectedCategory: {
		category: string;
		subcategory: string;
	} | null
}

const initialState: InitialState = {
	categories: null,
	selectedCategory: null,
	subcategories: null
}

const categoryReducer = (state = initialState, action: any) => {
	switch (action.type) {
		case SET_ALL_CATEGORY:
			return {
				...state, 
				categories: action.payload
			}
		case SET_ALL_SUBCATEGORY:
			return {
				...state, 
				subcategories: action.payload
			}
		case SET_SELECTED_CATEGORY:
			return {
				...state,
				selectedCategory: action.payload
			}
		default:
			return state;
  	}
};

export default categoryReducer;
